import React from 'react';
import { Producto } from '../types';

const CardProducto: React.FC<Producto> = ({ 
  titulo, 
  precio, 
  imagen, 
  categoria,
  descripcion 
}) => {
  const handleAddToCart = (): void => {
    alert(`${titulo} agregado al carrito`);
  };

  return (
    <div className="product-card-container">
      <div className="product-card">
        <div className="product-image-container">
          <img 
            src={imagen} 
            alt={titulo}
            className="product-image"
          />
          <div className={`category-badge ${categoria}`}>
            {categoria === 'cafe' ? '☕' : '🍰'}
          </div>
        </div>
        <div className="product-content">
          <h5 className="product-title">{titulo}</h5>
          {descripcion && (
            <p className="product-description">{descripcion}</p>
          )}
          <div className="product-footer">
            <span className="product-price">${precio.toFixed(2)}</span>
            <button 
              className="add-to-cart-btn"
              onClick={handleAddToCart}
            >
              🛒 Agregar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardProducto;